(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'DashboardConfigure',
	};

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		dragula([$('.dashboard-sections')[0]], {
			revertOnSpill: true,
		})
		.on('drop', function dropIt(this_el, target, source, sibling)
		{
			handleSortOrder();
		});
	};

	function handleSortOrder() {
		var sort_order  = '',
			counter     = 1,
			cur_html    = '',
			html_parts  = '';

		$('.dashboard-section:not(.gu-mirror)').each(function processSort() {
			sort_order += $(this).data('id') + ',';
		});

		$('#dashboardconfigure-dashboard_configuration').val(sort_order);

		$('.dashboard-section').each(function assignNumbers() {
			cur_html =  $(this).html();

			html_parts = cur_html.split('.');
			$(this).html(counter + '. ' + html_parts[1]);
			counter++;

			$('.positions').each(function relabelPositions() {
				if ($(this).data("position") === (counter -1)) {
					$(this).html(html_parts[1]);
				}
			});
		});
	}

}(jQuery, window.Adzuki || {}));